import Snippet from '../../../../components/Snippet/Snippet'
import { bg } from '../../../../assets/code-snippets/container/snip'

const Container = () => {
    return <div className="container fluid" id="intro">
        <div className="container fluid">
            <p className="text xl"><a href="#intro" className="link">&#128279;</a> Containers</p>
            <p className="text lg secondary">Containers are block elements used to group different kind of elements.</p>
            <p className="text md">By grouping all elements inside of a container this becomes their parent which enables us to apply a set of styles over these. Also the available containers are on different widths <span className="bold">which respond only on browser's width.</span></p>
        </div>
        <div className="container fluid my-4 py-4 px-2 shadow-lg rounded-md-lt">
            <p className="text md">To create a <code>container</code> :</p>
            <ol>
                <li>Create a <code>div</code> with class of <code>container</code></li>
                <li>Add to this element the desired width by adding one of the following
                    classes: </li>
                <ul>
                    <li><code>sm, md, lg, xl</code></li>
                    <li><code>fluid, regular</code></li>
                </ul>
            </ol>
        </div>

        <div className="container py-2 fluid">
            <div className="table rounded-md shadow-sm" padding="2" table-hover="true" table-striped="true">
                <table>
                    <thead>
                        <tr>
                            <th>Main</th>
                            <th>Additional</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><code>.container</code></td>
                            <td><code>.sm</code></td>
                            <td>sets the container the maximum width of: 576px</td>
                        </tr>
                        <tr>
                            <td><code>.container</code></td>
                            <td><code>.md</code></td>
                            <td>sets the container the maximum width of: 768px</td>
                        </tr>
                        <tr>
                            <td><code>.container</code></td>
                            <td><code>.lg</code></td>
                            <td>sets the container the maximum width of: 992px</td>
                        </tr>
                        <tr>
                            <td><code>.container</code></td>
                            <td><code>.xl</code></td>
                            <td>sets the container the maximum width of: 1200px</td>
                        </tr>
                        <tr>
                            <td><code>.container</code></td>
                            <td><code>.xxl</code></td>
                            <td>sets the container the maximum width of: 1400px</td>
                        </tr>
                        <tr>
                            <td><code>.container</code></td>
                            <td><code>.fluid</code></td>
                            <td>sets the container the maximum width of: 576px</td>
                        </tr>
                        <tr>
                            <td><code>.container</code></td>
                            <td><code>.regular</code></td>
                            <td>regular class will set multiple width on browser's width resize, such as:
                                <ul>
                                    <li>at 576px will define max-width as 500px</li>
                                    <li>at 768px will define max-width as 700px</li>
                                    <li>at 992px will define max-width as 900px</li>
                                    <li>at 1200px will define max-width as 1000px which is its maximum width size</li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div className="container py-2 fluid" id="background-color">
            <div className="container fluid">
                <p className="text xl"><a href="#background-color" className="link">&#128279;</a> Container background and color</p>
                <p className="text md">By adding one of the color classes to the  <code>container</code> class we can change the background and color of that specific container.</p>
            </div>
            <div className="row align-items-center">
                <div className="col md-III">
                    <div className="container fluid">
                        <Snippet code={bg} language='html' />
                    </div>
                </div>
                <div className="col md-III">
                    <div className="container sm shadow-md">
                        <div className="container sm p-2 primary">.primary</div>
                        <div className="container sm p-2 info">.info</div>
                        <div className="container sm p-2 danger">.danger</div>
                        <div className="container sm p-2 warning">.warning</div>
                        <div className="container sm p-2 light">.light</div>
                        <div className="container sm p-2 dark">.dark</div>
                        <div className="container sm p-2 success">.success</div>
                        <div className="container sm p-2 secondary">.secondary</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
}
export default Container